export default __webpack_public_path__ + "static/media/check-green.1cd8e93f.svg";